<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">{{ contractor.name }}</h4>
            </div>
            <edit-button @edit-click="editContractor"></edit-button>
          </md-card-header>
          <md-card-content>
            <div>
              <strong>Group Email</strong>
              <br />
              {{ contractor.email }}
              <i v-if="contractor.email == ''">Undefined</i>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Contractor Regions</h4>
            </div>
            <add-button @add-click="addContractorRegion"></add-button>
          </md-card-header>
          <md-card-content>
            <contractorRegionList></contractorRegionList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContractorRegionList from "./contractor-regions/ContractorRegionList";

export default {
  name: "ContractorView",
  components: {
    ContractorRegionList
  },
  computed: {
    ...mapGetters({
      contractor: "data-management-contractor/contractor"
    })
  },
  created() {
    this.$store.dispatch(
      "data-management-contractor/getContractorDetails",
      this.$route.params.contractorId
    );
  },
  methods: {
    addContractorRegion() {
      this.$router.push({ name: "Add Contractor Region" });
    },
    editContractor() {
      this.$router.push({
        name: "Edit Contractor",
        params: { contractorId: this.contractor.id }
      });
    }
  }
};
</script>

<style></style>
